import React from 'react';
import {
  ShoppingCart,
  Stethoscope,
  GraduationCap,
  Landmark,
  Home,
  Plane,
  Cloud,
  Factory
} from 'lucide-react';

const industries = [
  { icon: ShoppingCart, title: "E-Commerce" },
  { icon: Stethoscope, title: "Healthcare" },
  { icon: GraduationCap, title: "Education" },
  { icon: Landmark, title: "Finance" },
  { icon: Home, title: "Real Estate" },
  { icon: Plane, title: "Travel & Tourism" },
  { icon: Cloud, title: "SaaS / IT" },
  { icon: Factory, title: "Manufacturing" }
];

const Industry = () => {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">

      {/* Background Gloow */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[120px] rounded-full pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[120px] rounded-full pointer-events-none"></div>
  
      {/* GRID OVERLAY */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      {/* Grid Overlay */}
      <div className="absolute inset-0 opacity-[0.04] dark:opacity-[0.03]"
        style={{
          backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)',
          backgroundSize: '60px 60px'
        }}>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">

    <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
         Industries We {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              Serve
            </span>
          </h2>
      <p className="myparagraph text-gray-500">
 We deliver scalable digital solutions across multiple industries.</p>
      </div>
    

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((item, i) => (
            <div
              key={i}
              className="flex items-center p-6 bg-white dark:bg-[#1a1a1a] rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md transition-all duration-300"
            >
              <div className="w-12 h-12 bg-orange-50 dark:bg-orange-900/20 rounded-xl flex items-center justify-center mr-4">
                <item.icon className="w-6 h-6 text-primary" />
              </div>

              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {item.title}
              </h3>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Industry;